import { useQuery } from '@tanstack/react-query'

import { getMoneytreeStatus } from '@src/api'
import { DefaultApiGetMoneytreeStatusRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMoneytreeStatus = (
  params: DefaultApiGetMoneytreeStatusRequest
) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading, refetch } = useQuery({
    enabled: !!params,
    queryFn: () => getMoneytreeStatus(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_MONEYTREE_STATUS],
  })

  return { data, isError, isLoading, refetch }
}
